import script from "./UmbracoFormTitleAndDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoFormTitleAndDescription.vue?vue&type=script&setup=true&lang=ts"

import "./UmbracoFormTitleAndDescription.vue?vue&type=style&index=0&id=d9ad9a2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ad9a2e"]])

export default __exports__